import React from 'react';
import './App.css';
import { MyButton } from './components/MyButton';
import { Collection, IProduct } from './components/Products';
import { CollectionView } from './components/CollectionView';
import _ from "lodash";
import { DetailView } from './components/DetailView';
import { ajax } from 'rxjs/ajax';
import { CircularProgress } from '@mui/material';
import { MicroEventBus } from 'micro-event-bus';

export let microEventBus: MicroEventBus = (window as any).microEventBus;

interface IMoodleCourse {
  id: number;
  shortname: string;
  fullname: string;
  summary?: string;
  overviewfiles?: { fileurl: string }[];
}

interface IMoodleSession {
  token: string;
  userid: number;
}

export interface IAppProps{};
export interface IAppState {
  showDetails: boolean;
  product: IProduct | null;
  collectionInstance: Collection;
  username: string;
}

class App extends React.Component<IAppProps, IAppState>{
  constructor(props: IAppProps){
    super(props);
    this.showDetailView = this.showDetailView.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.processUserLoginEvent = this.processUserLoginEvent.bind(this);
    this.processMoodleSession = this.processMoodleSession.bind(this);

    this.state = {
      showDetails: false,
      product: null,
      collectionInstance: new Collection(),
      username: ""
    }
  }

  componentDidMount() {
    microEventBus.on('user-logged-in').subscribe(this.processUserLoginEvent);
    microEventBus.on('moodle-session').subscribe(this.processMoodleSession);
  }

  render() {
    return (
      <div>
          { this.state.collectionInstance.items.length < 1 ?
            <div className="App-header">
              <CircularProgress />
            </div>
            : ""}
          <CollectionView {...this.state.collectionInstance} handleItemClicked={this.showDetailView}/>
          <DetailView
            open={this.state.showDetails}
            product={this.state.product}
            handleClose={this.handleClose}
            username={this.state.username}
          />
      </div>
      );
  }

  handleClose(){
    console.log(`App.handleClick() called`);
    this.setState(prevState => ({
      showDetails: false,
      product: null
    }));
  }

  showDetailView(id: number){
    console.log(`App.handleClick() called`);
    let foundItem = _.find(
      this.state.collectionInstance.items,
      (item: IProduct) => {
        return item.id === id
      }
    );

    if(foundItem){
      this.setState({
        showDetails: true,
        product: foundItem
      })
    }
  }

  processUserLoginEvent(event: string | undefined) {
    console.log(`RCT : App.processUserLoginEvent : ${event}`);
    if (event) {
      this.setState({ username: event });
    }
  }

  processMoodleSession(session: IMoodleSession | undefined) {
    console.log('RCT : App.processMoodleSession :', session);
    if (!session) {
      return;
    }

    const url =
      `/moodle-api/webservice/rest/server.php` +
      `?wstoken=${session.token}` +
      `&wsfunction=core_enrol_get_users_courses` +
      `&userid=${session.userid}` +
      `&moodlewsrestformat=json`;

    ajax.getJSON(url).subscribe((response: any) => {
      console.log('RCT : Cours Moodle chargés :', response);

      if (response && response.exception) {
        console.log(`Erreur Moodle (cours) : ${response.message}`);
        return;
      }

      const courses = response as IMoodleCourse[];
      let collection = new Collection();
      collection.items = courses.map((course) => {
        let image = '/assets/react-app/images/no_course_picture.png';

        if (course.overviewfiles && course.overviewfiles.length > 0) {
          const fileurl = course.overviewfiles[0].fileurl;
          image = `${fileurl}${fileurl.includes('?') ? '&' : '?'}token=${session.token}`;
        }

        return {
          id: course.id,
          name: course.fullname,
          type: course.shortname,
          image,
          longDescription: (course.summary || '').replace(/<[^>]*>/g, ''),
          specs: {
            actuationForce: '',
            actuationPoint: '',
            bottomOut: '',
            bottomOutTravel: '',
            price: '0.00',
          },
        };
      });

      this.setState({
        showDetails: false,
        product: null,
        collectionInstance: collection,
      });
    });
  }
}

export default App;
